declare global {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface Window {
    ENV_API_URI: string;
  }
}

export const API_URI = window.ENV_API_URI;
